import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Slider_Small() {
  const settings2_withswipe = {
    className: "center",
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 1,
    swipeToSlide: true,
    afterChange: function(index) {console.log(`Slider Changed to: ${index + 1}, background: #222; color: #bada55`);}
  };

  function CustomNextArrow(props) {
    const { onClick } = props;return (<div className="neelan-next neelan-arrow" onClick={onClick}><img src="img/btn-next-dark.svg" alt="Next" width='30px' /></div>);
  }
  function CustomPrevArrow(props) {
    const { onClick } = props;return (<div className="neelan-prev neelan-arrow" onClick={onClick}><img src="img/btn-prev-dark.svg" alt="Next" width='30px' /></div>);
  }
  const settings2 = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    speed: 500,
    cssEase: "linear",
    nextArrow:<CustomNextArrow />,
    prevArrow:<CustomPrevArrow />,
  };


  
  return (
    
<div className="slider-container neel-slider neel-slider-sm bg-white">
      <Slider {...settings2}>
        <div><img src="/img/product/img1_1.png" className="img-fluid w-100"  /></div>
        <div><img src="/img/product/img1_2.png" className="img-fluid w-100" /></div>      
        <div><img src="/img/product/img1_3.png" className="img-fluid w-100" /></div>      
      </Slider>
    </div>
  );
}
export default Slider_Small;